export const DASHBOARD_TABS = [
  { id: 'overview', label: 'Overview', path: '/dashboard/overview' },
  { id: 'usage', label: 'Usage', path: '/dashboard/usage' },
  { id: 'reliability', label: 'Reliability', path: '/dashboard/reliability' },
  { id: 'response-quality', label: 'Response quality', path: '/dashboard/response-quality' },
  { id: 'spend', label: 'Spend', path: '/dashboard/spend' },
];

export function tabIdFromPathname(pathname) {
  const match = DASHBOARD_TABS.find((tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`));
  return match?.id ?? 'overview';
}

export function tabPathFromId(tabId) {
  return DASHBOARD_TABS.find((tab) => tab.id === tabId)?.path ?? '/dashboard/overview';
}
